import { gql } from "@shared/utils";
import { TextField } from "@mui/material";
import React, { FunctionComponent } from "react";

import { useGqlField } from "../../../../hooks";

import { DVInlineProps } from "./types";

const EDIT_TEXT = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, text: $value }) {
      _id
      text
    }
  }
`;

export const DVInlineText: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
}) => {
  const [text, setText] = useGqlField(
    dynamicVariable.text || "",
    dynamicVariable._id,
    EDIT_TEXT
  );
  return (
    <TextField
      size="small"
      value={text}
      onChange={(e) => setText(e.target.value)}
    />
  );
};
